import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';

import { Footer } from './footer';
import { Header, HeaderProps } from './header';

export const Shell = ({ ...headerProps }: HeaderProps) => {
  return (
    <Layout style={{ height: '100vh' }}>
      <Header {...headerProps} />
      <Outlet />
      <Footer />
    </Layout>
  );
};

export default Shell;
